import { createAction, EntityId } from '@reduxjs/toolkit'

export const poolNewTask = createAction<{
  id: EntityId
  relatedObjects: { entityName: string; entityIds: EntityId[] }[]
  title: string
  relatedLink?: string
}>('task/poolNewTask')

export const resolveTask = createAction<{
  id: EntityId
}>('task/resolveTask')
